import Badge from '../../components/Text/Badge';
import { SingleTextData } from '../../types/Text.types';
import { OptionType } from '../../components/Form/Select';
import { SingleJurisprudenciaData } from '../../types/Jurisprudencia.types';

export const getBadge = (textType: string) => {
  switch (textType) {
    case 'Nota de Rodapé':
      return <Badge color="blue">Nota de rodapé</Badge>;
    case 'Texto Comum':
    default:
      return <Badge color="green">Comum</Badge>;
  }
};

export const getInitialType = (type: string) => {
  switch (type) {
    case 'Texto comum':
      return { label: 'Texto comum', value: '1' };
    case 'Nota de Rodapé':
      return { label: 'Nota de rodapé', value: '2' };
  }
};

export const getFormattedInitialData = (data: SingleJurisprudenciaData | undefined) => {
  return {
    idJurisprudencia: data?.idJurisprudencia || '',
    nome: data?.nome || '',
    tribunal: data?.tribunal || '',
    orgao: data?.orgao || '',
    tipoDecisao: data?.tipoDecisao || '',
    dataPublicacao: data?.dataPublicacao || '',
    assunto: data?.assunto || '',
    area: data?.area || '',
    valorTexto: data?.valorTexto || '',
    enderecoArquivo: data?.enderecoArquivo || '',
  };
};
